import { WrappedWithRepromise } from '../../common/repromise';
import {
  PromptLoginCallback,
  TpaPage,
  TpaPageParams,
} from '../../Login/Widget/types';
import {
  CombinedCollectionSettings,
  ICaptchaSettings,
  IContactInfo,
} from '../../types';
import { ForcedState } from '../../../constants';

export enum PrivacyStatus {
  UNDEFINED = 'UNDEFINED',
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}
export type RegistrationOptions = {
  contactInfo?: IContactInfo;
  privacyStatus?: PrivacyStatus;
  recaptchaToken?: string | null;
  invisibleRecaptchaToken?: string | null;
  clientMetaData?: Record<string, any>;
};

export type PromptAuthPageCallback = <T extends TpaPage>(
  page: T,
  param?: TpaPageParams[T],
) => Promise<any>;

export type SignupCallback = (
  email: string,
  password: string,
  options: RegistrationOptions,
) => Promise<any>;

export type ControllerProps = {
  // All functions passed as props must be wrapped with repromise
  // They must be unwrapped with useRepromise before normal use
  register: WrappedWithRepromise<
    (email: string, password: string, options: RegistrationOptions) => void
  >;
  loginWithIdp: WrappedWithRepromise<
    (idpConnectionId: string, joinCommunity?: boolean) => Promise<void>
  >;
  promptLogin: WrappedWithRepromise<PromptLoginCallback>;
  closeLightbox: WrappedWithRepromise<() => void>;
  navigateToLink: WrappedWithRepromise<(link: any) => void>;

  formId: string;
  namespace: string;
  controllerSettings: CombinedCollectionSettings;
  captchaSettings: ICaptchaSettings;
  isEditor: boolean;
  isEditor3: boolean;
  isStudio2: boolean;
  isPreview: boolean;
  forceView: ForcedState;
  showPrivacyNote: boolean;
  // Whether this flow allows a post-auth redirect (set by thunderbolt).
  allowPostAuthRedirect?: boolean;
};
